module.exports = __webpack_public_path__ + "static/media/ins-5.071ac384.webp";